export interface InstalledChartMetadata {
  category?: string;
  frontendUrlPrefix?: string;
}

export interface InstalledChart {
  id: number;
  installChartName: string;
  metadata: InstalledChartMetadata;
}

export interface PaginatedInstalledChartsResponse {
  data: InstalledChart[];
  total: number;
  page: number;
  perPage: number;
  totalPages: number;
}

export interface MenuLink {
  name: string;
  url: string;
  category?: string;
}

// const getRootDomain = (hostOrUrl: string): string => {
//     // Ensure we can parse it with URL
//     const url = hostOrUrl.startsWith("http") ? new URL(hostOrUrl) : new URL(`https://${hostOrUrl}`);
//     const hostname = url.hostname;
//     const port = url.port ? `:${url.port}` : "";
//     const parts = hostname.split(".");

//     // localhost → return with port
//     if (hostname === "localhost") return hostname + port;

//     // sslip.io → keep last 3 parts
//     if (hostname.endsWith(".sslip.io")) return parts.slice(-5).join(".") + port;

//     // Normal domains → remove first label
//     return parts.slice(1).join(".") + port;
// };

const getRootDomain = (hostOrUrl: string): string => {
  const url = hostOrUrl.startsWith("http")
    ? new URL(hostOrUrl)
    : new URL(`https://${hostOrUrl}`);

  const hostname = url.hostname;
  const port = url.port ? `:${url.port}` : "";
  const parts = hostname.split(".");

  // localhost → return with port
  if (hostname === "localhost") return hostname + port;

  // sslip.io → keep last 3 parts
  if (hostname.endsWith(".sslip.io")) return parts.slice(-5).join(".") + port;

  // Keep full hostname
  return hostname + port;
};


const getUrlProtocol = (url: string, defaultProtocol = "https://"): string => {
  if (!url) return defaultProtocol;

  const trimmed = url.trim();

  // Match protocol (http:// or https://)
  const match = trimmed.match(/^(https?:\/\/)/i);
  return match ? match[1] : defaultProtocol;
};

class MenuService {

  async getMenuConfig(url): Promise<PaginatedInstalledChartsResponse> {
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error('API error');
      return await res.json();
    } catch {
      return { data: [], total: 0, page: 1, perPage: 0, totalPages: 0 };
    }
  }

  private setDefaultProtocol(url: string): string {
    // If protocol already exists (http:// or https://), keep it
    if (/^https?:\/\//i.test(url)) {
      return url;
    }

    // Otherwise default to https
    return `https://${url}`;
  }

  async getMenuLinks(BASE_URL): Promise<MenuLink[]> {
    const normalizedBaseUrl = this.setDefaultProtocol(BASE_URL);
    // Create a URL object from normalizedBaseUrl
    const urlObj = new URL(normalizedBaseUrl);

    // Add the 'containerisationbackend' subdomain
    urlObj.hostname = `containerisationbackend.${urlObj.hostname}`;
    
    const { data } = await this.getMenuConfig(`${urlObj.origin}/developer/charts/installed`);

    return data.map(d => {
        const frontendUrlPrefix = d.metadata?.frontendUrlPrefix;

        const rootDomain = getRootDomain(BASE_URL);
        const generatedUrl = `${getUrlProtocol(BASE_URL)}${frontendUrlPrefix}.${rootDomain}`;
    
        return {
          name: d.installChartName,
          url: frontendUrlPrefix ? generatedUrl : "",
          category: d.metadata?.category ?? "",
        };
    });
  }
}

export const menuService = new MenuService();